import { FunctionComponent } from "react";
import AcesoPage from "src/components/AcesoPage/AcesoPage";
import NoteList from 'src/components/NoteList/NoteList';

const NotesPage: FunctionComponent = () => {

    return <AcesoPage loading={false} titleKey="Notes" needsLogin={true}>
        <NoteList></NoteList>
    </AcesoPage>
};

export default NotesPage;